export default __webpack_public_path__ + "static/media/Address.e47beceb.png";